<template>
  <div class="ma-5">
    <div class="text-subtitle-1">Ajuste de notificaciones</div>
    <div class="text-caption">A continuación, podrás ajustar el tipo de comunicación que deseas recibir por parte de la 
      <b>Fundación United Way Colombia</b>, para nosotros es importante mantener canales de comunicación contigo ya que 
      a través de estos te podemos mantener informado de nuestra oferta.
    </div>
    <div>
      <v-table>
        <thead>
          <tr>
            <th class="text-left">
              Tipo de comunicación
            </th>
            <th class="">
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Llamadas telefónicas relacionadas con la Fundación.</td>
            <td class="">
              <v-switch v-model="comunications.call" color="primary" @update:model-value="updated"/>
            </td>
          </tr>
          <tr>
            <td>Mensajes a tu correo electrónico.</td>
            <td class="">
              <v-switch v-model="comunications.email" color="primary" @update:model-value="updated"/>
            </td>
          </tr>
          <tr>
            <td>Mensajes de texto con información relacionada a la Fundación.</td>
            <td class="">
              <v-switch v-model="comunications.sms" color="primary" @update:model-value="updated"/>
            </td>
          </tr>
          <tr>
            <td>Contacto a través de redes sociales o mensajes a través de Whatsapp u otras redes similares.</td>
            <td class="">
              <v-switch v-model="comunications.network" color="primary" @update:model-value="updated"/>
            </td>
          </tr>
        </tbody>
      </v-table>
    </div>
    <!-- Process -->
    <v-dialog v-model="process" max-width="320" persistent >
      <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
        <v-list-item prepend-icon="mdi-clock" title="Espera..." >
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>

    <!-- success -->
    <v-dialog v-model="success.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="success" icon="mdi-check-circle" size="112" />
        <h2 class="text-h5 mb-6">success</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ success.text }}
        </p>
        <v-divider class="mb-4"></v-divider>
        <div class="text-end">
          <v-btn class="text-none" color="success" variant="flat" text="Aceptar" @click="success.state = false"/>
      </div>
      </v-sheet>
    </v-dialog>
    
    <!-- error -->
    <v-dialog v-model="error.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-close-circle" size="112" />
        <h2 class="text-h5 mb-6">error</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ error.text }}
        </p>
        <v-divider class="mb-4"></v-divider>
        <div class="text-end">
          <v-btn class="text-none" color="error" variant="flat" text="Aceptar" @click="error.state = false"/>
      </div>
      </v-sheet>
    </v-dialog>
  </div>
</template>
<script setup>
  import Params from "@/models/params";
  import axios from "axios";
  import { ref, onMounted, reactive } from "vue";

  const comunications = reactive({
    call: !1,
    email: !1,
    sms: !1,
    network: !1
  })

  const success = reactive({
    state: false,
    text: null
  })

  const error = reactive({
    state: null,
    text: null
  })

  const process = ref(false)

  const params = ref(new Params)

  async function load(){
    const frm = new FormData;
    frm.append("action", "data");
    frm.append("object", "loadcommunication");
    frm.append("value", localStorage.document);
    frm.append("token", localStorage.tokenaccess);
    const result = await eject(frm);
    if(result.status && result.data.length > 0){
      comunications.call = Boolean(result.data[0].telefonica);
      comunications.email = Boolean(result.data[0].correo);
      comunications.sms = Boolean(result.data[0].sms);
      comunications.network = Boolean(result.data[0].redes);
    }
  }

  async function updated(){
    process.value = true;
    const frm = new FormData;
    frm.append("action", "updatecommunications");
    frm.append("data", JSON.stringify(comunications));
    frm.append("document", localStorage.document);
    frm.append("token", localStorage.tokenaccess);
    const result = await eject(frm);
    process.value = false;
    if(result.status){
      success.text = result.message;
      success.state = true;
    }else{
      error.text = 'Error al intentar actualizar las notificaciones.';
      error.state = true;
    }
  }

  function eject(f){
    return new Promise((resolve) => {
      axios.post(params.value.controller + 'beneficiario.php',f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
    })
  }

  onMounted(() => {
    load();
  })
</script>